import { FC } from "react";
import { useFormContext } from "react-hook-form";
import CustomRadio from "src/pages/DashboardPage/acadia/components/Tests/components/Ui/CustomRadio";

interface IProps {
  test: any;
}

export const TestRegistryItem: FC<IProps> = ({ test }) => {
  const { register, watch, setValue } = useFormContext();

  const selectedTestID = watch("TestID");

  const handleChangeRadio = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue("TestID", e.target.id, { shouldValidate: true });
  };

  return (
    <label className="p-5 bg-[#F3F4F6] mb-[10px] rounded-md block hover:cursor-pointer">
      <div className="text-black flex items-center gap-[10px]">
        <CustomRadio {...register(`Tests.${test.ID}`)} id={test.ID?.toString()} onChange={handleChangeRadio} checked={selectedTestID === test.ID?.toString()}>
          {test?.Title}
        </CustomRadio>
      </div>
      <div>
        <span>{test.Collections?.Title}</span> | <span>{test.QuestionsID?.length} Вопросов</span>
      </div>
    </label>
  );
};
